import React, { useEffect, useRef, useState } from 'react'

import { Image } from '@mui/icons-material'
import { Grid, GridSize } from '@mui/material'
import { ImageFieldProps, RaRecord, useRecordContext } from 'react-admin'

import { API } from '../../helpers/Api.helper'
import { getJWT } from '../../helpers/Auth.helper'
import styles from './LXImage.module.scss'

export const LXImage = (props: LXImageProps & ImageFieldProps): JSX.Element => {
  const { source, gridSize } = props
  const record = useRecordContext() || props.record
  let imageURL = record?.[source as string]
  const shouldDownloadViaAPI = source === 'logoBase64' && !imageURL
  if (shouldDownloadViaAPI) {
    imageURL = `${API.URL}/api/beneficiaries/${record?.id}/logo.png`
  }

  const [blobURL, setBlobURL] = useState<string | null>(null)
  const blobURLRef = useRef<string | null>(blobURL)
  blobURLRef.current = blobURL
  useEffect(() => {
    if (shouldDownloadViaAPI) {
      const fetchImage = async () => {
        try {
          const response = await fetch(imageURL, {
            headers: {
              [API.KEY_HEADER]: API.KEY,
              'x-current-pathname': window.location.pathname,
              Authorization: `Bearer ${getJWT()}`,
            },
          })
          if (!response.ok) {
            throw new Error('Failed to fetch image')
          }
          const blob = await response.blob()
          const url = URL.createObjectURL(blob)
          setBlobURL(url)
        } catch (error) {
          console.error(error)
        }
      }
      fetchImage()
    }
    // Cleanup: revoke blob URL when component unmounts or imageURL changes
    return () => {
      if (blobURLRef.current) {
        URL.revokeObjectURL(blobURLRef.current)
        blobURLRef.current = null
      }
    }
  }, [imageURL, shouldDownloadViaAPI])

  const displayURL = shouldDownloadViaAPI ? blobURL : imageURL

  return (
    <Grid item lg={gridSize || 2} className={styles.image}>
      {displayURL ? (
        <img src={displayURL} srcSet={displayURL} alt="LX logo" loading="lazy" />
      ) : (
        <Image className={styles.imageSVG} />
      )}
    </Grid>
  )
}

type LXImageProps = {
  source: string
  gridSize?: GridSize
  record?: RaRecord
}
